<template>
  <div>
    <!-- <v-layout row wrap> -->
    <v-text-field
      :browser-autocomplete="'off'"
      id="searchBox"
      single-line
      v-model="inputValue"
      @input="updateValue()"
      @keydown.down="down"
      @keydown.up="up"
      :placeholder="placeholder"
      :append-icon="inputValue!=''?'cancel':'search'"
      light
      hide-details
      @click:append="clear()"
      @click:clear="clear()"
    ></v-text-field>
    <v-menu :position-x="x" :position-y="y" offset-y absolute v-model="open">
      <v-list>
        <v-list-tile
          v-if="inputValue=='/'"
          :class="{'accent':isActive(index)}"
          v-for="(item, index) in matches"
          :key="index"
          @click="suggestionClick(index)"
        >
          <v-list-tile-title :class="{'white--text':isActive(index)}">{{ item }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <!--  </v-layout> -->
  </div>
</template>
<script>

import { EventBus } from '@/imports/EventBus';

export default {
  props: {
    /* value: {
      type: String,
      required: true
    }, */
    placeholder: "",
    suggestions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      inputValue: "",
      newSuges: null,
      open: false,
      current: 0,
      x: 0,
      y: 0
    };
  },
  created() {
    this.filterByProperty();
  },
  computed: {
    // Filtering the suggestion based on the input
    matches() {
      return this.newSuges.filter(obj => {
        return obj.indexOf(this.inputValue) >= 0;
      });
    }
  },
  methods: {
    updateValue() {
      if (this.open === false) {
        this.open = true;
        this.current = 0;
      }
      this.getOffset();
      this.$emit("input", this.inputValue);
    },
    getOffset() {
      var element = document.getElementById("searchBox");
      var rect = element.getBoundingClientRect();
      var elementLeft, elementTop; //x and y
      var scrollTop = document.documentElement.scrollTop
        ? document.documentElement.scrollTop
        : document.body.scrollTop;
      var scrollLeft = document.documentElement.scrollLeft
        ? document.documentElement.scrollLeft
        : document.body.scrollLeft;
      this.y = rect.top + scrollTop + 30;
      this.x = rect.left + scrollLeft;
    },
    // When enter pressed on the input
    enter() {
      this.$emit("input", this.matches[this.current]);
      this.inputValue = this.matches[this.current];
      this.open = false;
    },
    // When up pressed while suggestions are open
    up() {
      if (this.current > 0) {
        this.current--;
      } else {
        this.current = this.matches.length - 1;
      }
    },
    // When up pressed while suggestions are open
    down() {
      if (this.current < this.matches.length - 1) {
        this.current++;
      } else {
        this.current = 0;
      }
    },
    // For highlighting element
    isActive(index) {
      return index === this.current;
    },
    // When one of the suggestion is clicked
    suggestionClick(index) {
      this.$emit("input", this.matches[index]);
      this.inputValue = this.matches[index];
      this.open = false;
      document.getElementById("searchBox").focus();
    },
    filterByProperty() {
      var filtered = [];
      for (var i = 0; i < this.suggestions.length; i++) {
        var obj = this.suggestions[i];
        filtered.push(obj.langES);
      }
      this.newSuges = filtered;
    },
    clear() {
      document.getElementById("searchBox").value = "";
      this.$emit("clearQuery")
      this.inputValue = "";
    },
    setText(value) {
      document.getElementById("searchBox").value = "";
      this.inputValue = value;
    }
  }
};
</script>